module.exports = __webpack_public_path__ + "static/media/title1.b18b0382.jpg";